import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { hash } from '@/utils/cache';

export interface DynamicComponentProps {
  url: string;
  className?: string;
}

export function DynamicComponent({ url, className }: DynamicComponentProps) {
  const [isInitialized, setIsInitialized] = React.useState(false);
  const [html, setHtml] = useState<string | undefined>(undefined);

  useAsyncEffect(() => {
    fetch(url)
      .then((res) => {
        if (res.ok) {
          return res.text();
        }
        throw new Error(`Failed to fetch`);
      })
      .then((html) => {
        setHtml(html);
        setIsInitialized(true);
      })
      .catch(() => {
        setHtml(undefined);
        setIsInitialized(false);
      });
  }, [url]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isInitialized && html && (
        <>
          <div
            id={`dyn-${hash(url)}`}
            className={`dynamic-component ${className}`}
            /* eslint-disable-next-line react/no-danger */
            dangerouslySetInnerHTML={{ __html: html }}
          />
          <div style={{ opacity: `0`, height: `0px` }} />
        </>
      )}
    </>
  );
}
